import { createFileRoute } from '@tanstack/react-router'
import type { BlogPost } from '@/types'
import { ArticleCard } from '@/features/blog/components/ArticleCard'

export const Route = createFileRoute('/blog')({
  component: BlogPage,
  loader: async () => {
    try {
      const response = await fetch('/data/blog-posts.json')
      const posts: BlogPost[] = await response.json()
      return { posts }
    } catch {
      return { posts: [] }
    }
  },
})

function BlogPage() {
  const { posts } = Route.useLoaderData()

  return (
    <div className="container mx-auto px-4 py-8">
      <header className="max-w-2xl mx-auto text-center mb-12">
        <h1 className="text-4xl font-serif font-bold mb-4">Blog</h1>
        <p className="text-gray-600 text-lg">
          Insights, stories, and updates from our team.
        </p>
      </header>

      {posts.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-600">No articles yet. Check back soon!</p>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {posts.map((post) => (
            <ArticleCard key={post.id} post={post} />
          ))}
        </div>
      )}
    </div>
  )
}
